﻿let UserSession = require('../UserSession')

module.exports = LuminateSessionSync;

function LuminateSessionSync(options) {
    if (options.isUserSignedIn) {
        new UserSession().syncSession().done();
    }
}